import { render, staticRenderFns } from "./cargoDocExtendHplCopyDialog.vue?vue&type=template&id=e23515de&"
import script from "./cargoDocExtendHplCopyDialog.vue?vue&type=script&lang=js&"
export * from "./cargoDocExtendHplCopyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e23515de')) {
      api.createRecord('e23515de', component.options)
    } else {
      api.reload('e23515de', component.options)
    }
    module.hot.accept("./cargoDocExtendHplCopyDialog.vue?vue&type=template&id=e23515de&", function () {
      api.rerender('e23515de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/edi/cargoDocExtendHplCopyDialog.vue"
export default component.exports